<template>
   <info-box
      :title="'Channels'">

      <!--Content to be placed in InfoBox's block-section-wrapper-->
      <div class="block-channels-list" id="channel_selections">
         <div v-if="isLoading">
            <div class="loader-wrapper">
               <div class="loader">
               </div>
            </div>
         </div>

         <check
            v-else
            v-for="(value, key) in channelOptions"
            :key="key"
            :value="value.recid"
            :text="value.name"
            :isChecked="initialSelected.includes(value.recid)"
            v-on:input="onCheck"
         > 
         </check>
      </div>

   </info-box>
</template>

<script>
import Vue from "vue";
import BaseCheckInfoBox from './BaseCheckInfoBox';

import { mapActions, mapState } from 'vuex';

export default {
   extends: BaseCheckInfoBox,

   props: {
      channelRecid: Number | String
   },

   computed: {
      ...mapState('global', [
         'channelOptions',
         'isLoadingChannels'
      ]),

      isLoading() {
         return this.isLoadingChannels;
      }
   },
   
   // created() {  

   //    if (this.channelRecid != '' && this.channelRecid != undefined) {
   //       this.initialSelected.push(this.channelRecid);
   //    }
   // },

   methods: {
      ...mapActions('global', ['fetchChannels']),
      getOptions() {
         this.fetchChannels({vm: this});
      }
   }
}
</script>